import { Table } from "react-bootstrap";

function TableGetSatisfactionLevelQuestionThree(props) {
  return (
    <>
        <Table striped bordered hover>
          <tbody>
            {props.data.map((el) => {
              return (
                <tr key={el.id}>
                  <td>{el.label}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
    </>
  );
}

export { TableGetSatisfactionLevelQuestionThree };
